// src/reducers/root_reducer.js

import { combineReducers } from 'redux';
import attachments from './attachments_reducer'
import author from './author_reducer'
import devices from './device_reducer'
import errors from './errors_reducer';
import feedback from './feedback_reducer'
import management from './management_reducer'
import models from './models_reducer'
import model_uploader from './model_uploader_reducer'
import notifications from './notification_reducer'
import previewer from './preview_reducer'
import session from './session_reducer';
import tags from './tags_reducer'
import tables from './tables_reducer'
import users from './users_reducer'
import work_instructions from './work_instructions/work_instructions_reducer'

const RootReducer = combineReducers({
    attachments,
    author,
    devices,
    errors,
    feedback,
    management,
    models,
    model_uploader,
    notifications,
    previewer,
    session,
    tags,
    tables,
    users,
    work_instructions,
});

export default RootReducer;